module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre7"
  }, [_c('br', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_7"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre38"
  }, [_c('span', {
    staticClass: "calibre39"
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre15"
  }, [_vm._v("It is the year 1968, in the small town of Huckster, Illinois and there are some strange goings on at the abandoned mill just outside of town. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre15"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre15"
  }, [_vm._v("Thirty two years ago a young mill hand, Marty, who worked at the Faversham mill, got caught with more than his hands in the owner’s daughter's cookie jar. Finding himself without a job and girlfriend the very next day, Marty decides to leave town with a goodbye gift for the owner. He decides to burn the place to the ground. His plan goes horribly wrong and the mill is shut down, along with the many ghosts who were left imprisoned there. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre15"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre15"
  }, [_vm._v("Now, thirty two years later, a group of young teens find themselves in a whirlwind of confusion and terror as they are swept up in the mill’s revenge. Will these unlikely heroes complete their tasks or will they travel through the looking glass forever and ever? One thing is for sure, the ride will be exciting, frightening and often funny. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre15"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('span', {
    staticClass: "calibre40"
  }, [_vm._v("The Mill is a story like no other.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre41"
  }, [_c('span', {
    staticClass: "calibre39"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre7"
  }, [_c('span', {
    staticClass: "calibre8",
    attrs: {
      "id": "calibre_pb_8"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f63f63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_004.vue
// module id = 72
// module chunks = 0